import { APP_SESSION_STORAGE_KEY, NOVA_LOGIN_STORAGE_KEY } from "@/static/UserAction"

export function isNovaLoginUrl(search: string = window.location.search): boolean {
  const params = new URLSearchParams(search)
  const loginSource = params.get("login_source")

  if (loginSource === "nova") {
    return true
  }

  if (loginSource) {
    return false
  }

  // Rétrocompatibilité des liens Nova existants sans login_source
  return params.get("force_login") === "true"
}

export function markNovaLoginSession(): void {
  sessionStorage.setItem(NOVA_LOGIN_STORAGE_KEY, "1")
  sessionStorage.setItem(APP_SESSION_STORAGE_KEY, "1")
}

/** À appeler avant le bootstrap Vue pour éviter les courses avec App.vue. */
export function markNovaLoginSessionFromUrlIfPresent(): void {
  if (isNovaLoginUrl()) {
    markNovaLoginSession()
  }
}

export function isNovaLoginSession(): boolean {
  return isNovaLoginUrl() || sessionStorage.getItem(NOVA_LOGIN_STORAGE_KEY) === "1"
}
